<script setup lang="ts">
import { useDark, useToggle } from '@vueuse/core'
import NavyButton from '@/volt/NavyButton.vue';

const isDark = useDark();
const toggleDark = useToggle(isDark);

</script>

<template>
  <NavyButton @click="toggleDark()" class="text-sm" :icon="(isDark ? 'pi pi-moon' : 'pi pi-sun')" v-ripple />
</template>